module.exports = __webpack_public_path__ + "media/social/link-mail-5744c67e.png";